import { CommonModule } from '@angular/common';
// Modules
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class QuickflowsMenuModule {
}
QuickflowsMenuModule.ɵfac = function QuickflowsMenuModule_Factory(t) { return new (t || QuickflowsMenuModule)(); };
QuickflowsMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: QuickflowsMenuModule });
QuickflowsMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, IconSearchAutocompleteModule, TooltipModule] });
